<template>
  <div class="zg-bio">
    <h2 v-if="name">
      {{ name }}
    </h2>

    <div class="bio">
      <slot v-if="$slots.default" />

      <p v-else-if="text">
        {{ text }}
      </p>
    </div>

    <span v-if="date">
      {{ date }}
    </span>

    <zg-button-link
      v-if="link && link.href && link.text"
      :href="link.href"
      :text="link.text"
      :button-props="{
        link: true,
        size: 'medium',
        icons: { right: 'arrow-forward' }
      }"
    />
  </div>
</template>

<script>
  import ZgButtonLink from '../ZgButtonLink/ZgButtonLink'

  export default {
    name: 'ZgBio',
    components: {
      ZgButtonLink
    },
    props: {
      name: {
        type: String,
        required: false,
        default: null
      },
      text: {
        type: String,
        required: false,
        default: null
      },
      date: {
        type: String,
        required: false,
        default: null
      },
      link: {
        type: Object,
        required: false,
        default: () => {},
        validator: link => !link || (link.text && link.href)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-bio {
    display: flex;
    flex-direction: column;
    gap: rem(14px);

    h2 {
      @include type-title-m;

      margin: 0;
    }

    .bio {
      p,
      ::v-deep p {
        @include type-body-m;

        &:last-child {
          margin: 0;
        }
      }
    }

    & > span {
      @include type-body-s;

      color: color(gray-500);
      margin: 0;
    }
  }
</style>
